import { render, staticRenderFns } from "./cursoVirtual.vue?vue&type=template&id=33131ec0"
import script from "./cursoVirtual.vue?vue&type=script&lang=js"
export * from "./cursoVirtual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports